<script>
import 'bulma/css/bulma.css'
import { hasAdminRole, countCharacters, sortArraybyCreatedAt } from '@/api/Utilities.js'
import * as constant from '@/constant/constant.js'
import modalWindow from '@/components/ModalWindow'
// v9 moduler 方式
import { firebaseApp } from '@/firebase.js'
import { getAnalytics, logEvent } from 'firebase/analytics'
import { getMyUserId } from '@/api/FirebaseUserWrapper.js'
import { addCard } from '@/api/FirebaseBoardWrapper.js'
import card from './Card'
import showCard from './showCard'
const analytics = getAnalytics(firebaseApp)
require('../../css/style.css')

function addNumber (arrayTmp) {
  let array = []
  let count = 0
  for (const card of arrayTmp) {
    let tempCard = card
    tempCard.number = count
    count++
    array.push(tempCard)
  }
  return array
}

export default {
  props: [
    'boardcards'
  ],
  components: {
    card,
    showCard,
    modalWindow
  },
  data () {
    return {
      DEVIDE_NUM: 5,
      nodeWidth: 150,
      nodeHeight: 130,
      nodeMarginX: 25,
      nodeMarginY: 20,
      temporaryPosX: 0,
      temporaryPosY: 0,
      graphWidth: 0,
      teamId: '',
      userId: '',
      clickedCardId: '',
      resizeObserver: undefined,
      isResizeObserver: false,
      cardData: [],
      title: constant.DEFAULT_DOMAIN_TITLE,
      Q_LENGTH: 1000,
      enableAddModal: false,
      selectColor: 'soso',
      msg: '',
      msgLength: 0,
      alertMsg: '',
      targetNode: {},
      enableEditNode: false
    }
  },
  beforeDestroy () {
    this.resizeObserver.unobserve(this.$refs.board) // 検知終了
    this.resizeObserver.disconnect(this.$refs.board) // 開放
    document.title = this.title
    document.querySelector("meta[property='og:title']").setAttribute('content', this.title)
  },
  async created () {
    // 初期化
    this.init()
    this.userId = await getMyUserId()
    document.title = 'チーム | ' + this.title
    document.querySelector("meta[property='og:title']").setAttribute('content', 'チーム | ' + this.title)
    // =================== GOOGLE ANALYTICS ===================
    if (hasAdminRole(this.userId)) {
      console.log('YOU ARE DEVELOPPER AND EXCLUDED FROM ANALYSIS')
    } else {
      logEvent(analytics, 'teams/Teams')
    }
  },
  computed: {
    rows: function () {
      if (!this.msg) { return 6 }
      const length = this.msg.split('\n').length
      const num = (length > 6) ? length : 6
      return (num < 15) ? num : 15
    }
  },
  async mounted () {
    // サイドバーで動的に画面幅が変わるので検知するリスナーを貼る
    this.graphWidth = this.$refs.board.getBoundingClientRect().width
    this.resizeObserver = new ResizeObserver((entries, observer) => {
      this.isResizeObserver = !this.isResizeObserver
    })
    this.resizeObserver.observe(this.$refs.board)
  },
  watch: {
    boardcards: function (val) {
      this.renderBoard()
    },
    isResizeObserver: function () {
      this.handleResize()
    },
    async $route (to, from) {
      // ルートの変更の検知...user/:A to user/:Bの際に画面描画されないため
      if (from.path !== to.path) {
        // 初期化
        this.init()
      }
    },
    msg: function (val) {
      this.msgLength = countCharacters(this.msg)
    }
  },
  methods: {
    handleResize: function () {
      this.graphWidth = this.$refs.board.getBoundingClientRect().width
    },
    init () {
      // Boardの表示設定
      this.teamId = this.$route.params.teamId
      this.$emit('showBoard', this.teamId)
    },
    calcLayerNum (arrayTmp) {
      let array = []
      let count = 0
      for (const card of arrayTmp) {
        let tempCard = card
        tempCard.layerNum = count % this.DEVIDE_NUM
        count++
        array.push(tempCard)
      }
      return array
    },
    calcCardPosition (arrayTmp) {
      let array = []
      for (const card of arrayTmp) {
        let tempCard = card
        tempCard.posx += Math.floor(card.number / this.DEVIDE_NUM) * (this.nodeWidth + this.nodeMarginX) + ((this.nodeWidth + this.nodeMarginX) / 2.0)
        tempCard.posy = tempCard.layerNum * this.nodeHeight + this.nodeMarginY
        array.push(tempCard)
      }
      return array
    },
    renderBoard () {
      // initialize
      let tempCards = []
      // 配列Objectに要素childs[],layerNum, posxを追加
      for (const card of this.boardcards) {
        let data = card
        data.layerNum = 0
        data.posx = 0
        data.posy = 0
        data.number = 0
        tempCards.push(data)
      }
      // cardをcreatAt順でソートする
      tempCards = sortArraybyCreatedAt(tempCards)
      // cardにdataNumberを付与する
      tempCards = addNumber(tempCards)
      // cardの縦位置を計算する.(自分の存在するlayerが何番目か求める)
      tempCards = this.calcLayerNum(tempCards)
      // 位置座標を計算する
      this.cardData = this.calcCardPosition(tempCards)
    },
    clickCard (id) {
      this.clickedCardId = id
      const index = this.boardcards.findIndex(({id}) => id === this.clickedCardId)
      this.targetNode = this.boardcards[index]
    },
    addCard () {
      this.enableAddModal = true
    },
    closeAddModal () {
      this.enableAddModal = false
    },
    async keyDownCtrlEnter () {
      await this.postCard()
    },
    async postCard () {
      this.alertMsg = ''
      if (this.msgLength === 0) {
        this.alertMsg = '入力がありません'
      }
      await addCard(this.teamId, null, null, null, this.selectColor, this.msg)
      // 初期化
      this.msg = ''
      this.selectColor = 'soso'
      this.enableAddModal = false
    },
    enableEditCard (flag, id) {
      this.enableEditNode = flag
      this.clickedCardId = id
      const index = this.boardcards.findIndex(({id}) => id === this.clickedCardId)
      this.targetNode = this.boardcards[index]
    },
    endEditNode () {
      this.enableEditNode = false
    }
  }
}
</script>
<style scoped>
.fixed-top {
  position: fixed;
  z-index: 5;
}
.board {
  margin: auto;
  height: 130vh;
}
.content {
  position: relative;
  width: 100%;
  height: 100%;
}
.board-content {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.board::-webkit-scrollbar {
  display:none;
}
.buttons:not(:last-child) {
  margin-bottom: 0rem;
}
.buttons .button {
  margin-bottom: 0rem;
}
.card-foot {
  margin-bottom: 10px;
}
.fixed-bottom {
  bottom: 0;
  position: fixed;
}
</style>
<template>
  <div class="board-all">
    <div class="fixed-top">
      <div class="buttons has-addons is-left">
        <button class="button is-small is-link" @click="addCard()">
          <span class="icon is-small">
            <i class="fa-solid fa-circle-plus"></i>
          </span>
        </button>
      </div>
    </div>
    <div ref="board" class="board">
      <div class="content">
        <card class="board-content"
        v-for="data in cardData"
        :key="data.id"
        :card="data"
        :x="data.posx"
        :y="data.posy"
        :w="nodeWidth"
        :h="nodeHeight"
        :marginX="nodeMarginX"
        :marginY="nodeMarginY"
        :teamId="teamId"
        :clickedCardId="clickedCardId"
        @clickCard="clickCard"
        @enableEditCard="enableEditCard"
        />
      </div>
      <div class="add-modal">
        <modalWindow @close="closeAddModal" v-if="enableAddModal">
          <template slot="header">
            <div class="columns is-marginless">
              <div class="column is-paddingless is-three-quarters has-text-left">
                <span class="text has-text-white">新規作成</span>
              </div>
              <div class="column is-paddingless">
                <div class="buttons is-right">
                  <button class="delete" @click="closeAddModal"></button>
                </div>
              </div>
            </div>
          </template>
          <!-- color -->
          <div class="color-switch">
            <div class="control">
              <label class="radio">
                <input type="radio" value="thinking" v-model="selectColor">
                <span class="text has-text-danger">
                  <i class="fa-solid fa-square"></i>
                </span>
              </label>
              <label class="radio">
                <input type="radio" value="soso" v-model="selectColor">
                <span class="text has-text-warning">
                  <i class="fa-solid fa-square"></i>
                </span>
              </label>
              <label class="radio" disabled>
                <input type="radio" value="important" v-model="selectColor">
                <span class="text has-text-success">
                  <i class="fa-solid fa-square"></i>
                </span>
              </label>
            </div>
          </div>
          <!-- 1000文字未満 -->
          <textarea v-if="msgLength<=Q_LENGTH" class="textarea" ref="textInput" placeholder="メモやメッセージを書く" v-model="msg" :rows="rows" @keydown.ctrl.enter="keyDownCtrlEnter()" @keydown.meta.enter="keyDownCtrlEnter()"></textarea>
          <!-- 1000文字以上 -->
          <textarea v-else class="textarea is-danger" ref="textInput" placeholder="メモやメッセージを書く" v-model="msg" :rows="rows" @keydown.ctrl.enter="keyDownCtrlEnter()" @keydown.meta.enter="keyDownCtrlEnter()"></textarea>
          <!-- state bar -->
          <div class="state-bar">
            <div class="columns is-mobile is-marginless">
              <div class="column is-three-quarters">
                <div class="add-paddingleft">
                  <progress class="progress is-gray is-small" :value="msgLength" :max="Q_LENGTH"></progress>
                </div>
              </div>
              <div class="column is-size-7">残り{{Q_LENGTH-msgLength}}</div>
            </div>
          </div>
          <p class="help is-danger">{{alertMsg}}</p>
          <template slot="footer">
            <div class="card-foot">
              <div class="buttons is-centered">
                <button class="button is-small" @click="closeAddModal">キャンセル</button>
                &nbsp;
                &nbsp;
                &nbsp;
                <button class="button is-small is-link" @click="postCard()">SAVE</button>
              </div>
            </div>
          </template>
        </modalWindow>
      </div>
    </div>
    <div class="fixed-bottom" v-bind:style="{ width: graphWidth - 3 + 'px' }">
      <showCard v-if="clickedCardId"
      :card = "targetNode"
      :nodeId = "clickedCardId"
      :teamId = "teamId"
      :loginUserId="userId"
      :enableEditNode = "enableEditNode"
      @endEditNode= "endEditNode"
      />
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// src/pages/board/Board.vue